export const DESKTOP_ENVIRONMENT = {
	mediaType: 'screen',
	anyHover: 'hover',
	anyPointer: 'fine',
	colorGamut: 'srgb-but-not-p3',
	grid: 'bitmap',
	hover: 'hover',
	overflowBlock: 'scroll',
	overflowInline: 'scroll',
	pointer: 'fine',
	scan: 'progressive',
	update: 'fast',
	colorIndex: 'none',
	colorBits: 8,
	monochromeBits: 'not-monochrome',
	displayMode: 'browser',
	dynamicRange: 'not-hdr',
	environmentBlending: 'opaque',
	forcedColors: 'none',
	invertedColors: 'none',
	navControls: 'back',
	prefersColorScheme: 'no-preference',
	prefersContrast: 'no-preference',
	prefersReducedData: 'no-preference',
	prefersReducedMotion: 'no-preference',
	prefersReducedTransparency: 'no-preference',
	scripting: 'enabled',
	videoColorGamut: 'srgb-but-not-p3',
	videoDynamicRange: 'not-hdr',
	horizontalViewportSegments: 1,
	verticalViewportSegments: 1
}
const e = e => new Error(`Invalid option: ${e}`)
export const validateEnv = o => {
	if ('screen' !== o.mediaType && 'print' !== o.mediaType && 'not-screen-or-print' !== o.mediaType)
		throw e('mediaType')
	if ('none' !== o.anyHover && 'hover' !== o.anyHover) throw e('anyHover')
	if ('none' !== o.anyPointer && 'coarse' !== o.anyPointer && 'fine' !== o.anyPointer)
		throw e('anyPointer')
	if (
		'not-srgb' !== o.colorGamut &&
		'srgb-but-not-p3' !== o.colorGamut &&
		'p3-but-not-rec2020' !== o.colorGamut &&
		'rec2020' !== o.colorGamut
	)
		throw e('colorGamut')
	if ('bitmap' !== o.grid && 'grid' !== o.grid) throw e('grid')
	if ('none' !== o.hover && 'hover' !== o.hover) throw e('hover')
	if ('none' !== o.overflowBlock && 'scroll' !== o.overflowBlock && 'paged' !== o.overflowBlock)
		throw e('overflowBlock')
	if ('none' !== o.overflowInline && 'scroll' !== o.overflowInline) throw e('overflowInline')
	if ('none' !== o.pointer && 'coarse' !== o.pointer && 'fine' !== o.pointer) throw e('pointer')
	if ('interlace' !== o.scan && 'progressive' !== o.scan) throw e('scan')
	if ('none' !== o.update && 'slow' !== o.update && 'fast' !== o.update) throw e('update')
	if (!(Number.isInteger(o.widthPx) && o.widthPx >= 0)) throw e('widthPx')
	if (!(Number.isInteger(o.heightPx) && o.heightPx >= 0)) throw e('heightPx')
	if (!(Number.isInteger(o.deviceWidthPx) && o.deviceWidthPx >= 0)) throw e('deviceWidthPx')
	if (!(Number.isInteger(o.deviceHeightPx) && o.deviceHeightPx >= 0)) throw e('deviceHeightPx')
	if (!(Number.isInteger(o.colorBits) && o.colorBits >= 0)) throw e('colorBits')
	if (o.dppx <= 0) throw e('dppx')
	if (
		'not-monochrome' !== o.monochromeBits &&
		!(Number.isInteger(o.monochromeBits) && o.monochromeBits >= 0)
	)
		throw e('monochromeBits')
	if ('none' !== o.colorIndex && !(Number.isInteger(o.colorIndex) && o.colorIndex >= 0))
		throw e('colorIndex')
}
export const matches = (e, o) => {
	const r = {...DESKTOP_ENVIRONMENT, ...o}
	validateEnv(r)
	for (const o of e.simplePerms) {
		let e = !0
		for (const i in o) {
			const t = i,
				n = o
			if ('media-type' === t) {
				const o = n[t]
				if ('print' === o) {
					if ('screen' === r.mediaType || 'not-screen-or-print' === r.mediaType) {
						e = !1
						break
					}
				} else if ('screen' === o) {
					if ('print' === r.mediaType || 'not-screen-or-print' === r.mediaType) {
						e = !1
						break
					}
				} else if ('not-screen' === o) {
					if ('screen' === r.mediaType) {
						e = !1
						break
					}
				} else if ('print' === r.mediaType) {
					e = !1
					break
				}
			} else if ('any-hover' === t) {
				if (n[t] !== r.anyHover) {
					e = !1
					break
				}
			} else if ('hover' === t) {
				if (n[t] !== r.hover) {
					e = !1
					break
				}
			} else if ('any-pointer' === t) {
				if (n[t] !== r.anyPointer) {
					e = !1
					break
				}
			} else if ('pointer' === t) {
				if (n[t] !== r.pointer) {
					e = !1
					break
				}
			} else if ('grid' === t) {
				const o = n[t]
				if ((0 === o && 'grid' === r.grid) || (1 === o && 'bitmap' === r.grid)) {
					e = !1
					break
				}
			} else if ('color-gamut' === t) {
				const [o, i, s, c] = n[t]
				if (
					('not-srgb' === r.colorGamut && !o) ||
					('srgb-but-not-p3' === r.colorGamut && !i) ||
					('p3-but-not-rec2020' === r.colorGamut && !s) ||
					('rec2020' === r.colorGamut && !c)
				) {
					e = !1
					break
				}
			} else if ('video-color-gamut' === t) {
				const [o, i, s, c] = n[t]
				if (
					('not-srgb' === r.videoColorGamut && !o) ||
					('srgb-but-not-p3' === r.videoColorGamut && !i) ||
					('p3-but-not-rec2020' === r.videoColorGamut && !s) ||
					('rec2020' === r.videoColorGamut && !c)
				) {
					e = !1
					break
				}
			} else if ('overflow-block' === t) {
				if (n[t] !== r.overflowBlock) {
					e = !1
					break
				}
			} else if ('overflow-inline' === t) {
				if (n[t] !== r.overflowInline) {
					e = !1
					break
				}
			} else if ('scan' === t) {
				if (n[t] !== r.scan) {
					e = !1
					break
				}
			} else if ('update' === t) {
				if (n[t] !== r.update) {
					e = !1
					break
				}
			} else if ('scripting' === t) {
				if (n[t] !== r.scripting) {
					e = !1
					break
				}
			} else if ('display-mode' === t) {
				if (n[t] !== r.displayMode) {
					e = !1
					break
				}
			} else if ('environment-blending' === t) {
				if (n[t] !== r.environmentBlending) {
					e = !1
					break
				}
			} else if ('forced-colors' === t) {
				if (n[t] !== r.forcedColors) {
					e = !1
					break
				}
			} else if ('inverted-colors' === t) {
				if (n[t] !== r.invertedColors) {
					e = !1
					break
				}
			} else if ('nav-controls' === t) {
				if (n[t] !== r.navControls) {
					e = !1
					break
				}
			} else if ('prefers-color-scheme' === t) {
				if (n[t] !== r.prefersColorScheme) {
					e = !1
					break
				}
			} else if ('prefers-contrast' === t) {
				if (n[t] !== r.prefersContrast) {
					e = !1
					break
				}
			} else if ('prefers-reduced-data' === t) {
				if (n[t] !== r.prefersReducedData) {
					e = !1
					break
				}
			} else if ('prefers-reduced-motion' === t) {
				if (n[t] !== r.prefersReducedMotion) {
					e = !1
					break
				}
			} else if ('prefers-reduced-transparency' === t) {
				if (n[t] !== r.prefersReducedTransparency) {
					e = !1
					break
				}
			} else if ('dynamic-range' === t) {
				if ('high' === n[t] && 'not-hdr' === r.dynamicRange) {
					e = !1
					break
				}
			} else if ('video-dynamic-range' === t) {
				if ('high' === n[t] && 'not-hdr' === r.videoDynamicRange) {
					e = !1
					break
				}
			} else if ('vertical-viewport-segments' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.verticalViewportSegments < i ||
					r.verticalViewportSegments > s ||
					(i === r.verticalViewportSegments && !o) ||
					(s === r.verticalViewportSegments && !c)
				) {
					e = !1
					break
				}
			} else if ('horizontal-viewport-segments' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.horizontalViewportSegments < i ||
					r.horizontalViewportSegments > s ||
					(i === r.horizontalViewportSegments && !o) ||
					(s === r.horizontalViewportSegments && !c)
				) {
					e = !1
					break
				}
			} else if ('width' === t) {
				const [o, i, s, c] = n[t]
				if (r.widthPx < i || r.widthPx > s || (i === r.widthPx && !o) || (s === r.widthPx && !c)) {
					e = !1
					break
				}
			} else if ('device-width' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.deviceWidthPx < i ||
					r.deviceWidthPx > s ||
					(i === r.deviceWidthPx && !o) ||
					(s === r.deviceWidthPx && !c)
				) {
					e = !1
					break
				}
			} else if ('height' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.heightPx < i ||
					r.heightPx > s ||
					(i === r.heightPx && !o) ||
					(s === r.heightPx && !c)
				) {
					e = !1
					break
				}
			} else if ('device-height' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.deviceHeightPx < i ||
					r.deviceHeightPx > s ||
					(i === r.deviceHeightPx && !o) ||
					(s === r.deviceHeightPx && !c)
				) {
					e = !1
					break
				}
			} else if ('color' === t) {
				const [o, i, s, c] = n[t]
				if (
					r.colorBits < i ||
					r.colorBits > s ||
					(i === r.colorBits && !o) ||
					(s === r.colorBits && !c)
				) {
					e = !1
					break
				}
			} else if ('monochrome' === t) {
				const [o, i, s, c] = n[t]
				if ('not-monochrome' === r.monochromeBits)
					(i > 0 || (0 === i && !o) || (0 === s && !c)) && (e = !1)
				else if (
					r.monochromeBits < i ||
					r.monochromeBits > s ||
					(i === r.monochromeBits && !o) ||
					(s === r.monochromeBits && !c)
				) {
					e = !1
					break
				}
			} else if ('resolution' === t) {
				const [o, i, s, c] = n[t]
				if (r.dppx < i || r.dppx > s || (i === r.dppx && !o) || (s === r.dppx && !c)) {
					e = !1
					break
				}
			} else if ('color-index' === t) {
				const [o, i, s, c] = n[t]
				if ('none' === r.colorIndex) {
					if (i > 0 || (0 === i && !o) || (0 === s && !c)) {
						e = !1
						break
					}
				} else if (
					r.colorIndex < i ||
					r.colorIndex > s ||
					(i === r.colorIndex && !o) ||
					(s === r.colorIndex && !c)
				) {
					e = !1
					break
				}
			} else if ('aspect-ratio' === t) {
				const [o, i, s, c] = n[t],
					a = i[0] / i[1],
					l = s[0] / s[1],
					f = r.widthPx / r.heightPx
				if (f < a || f > l || (a === f && !o) || (l === f && !c)) {
					e = !1
					break
				}
			} else {
				const [o, i, s, c] = n[t],
					a = i[0] / i[1],
					l = s[0] / s[1],
					f = r.deviceWidthPx / r.deviceHeightPx
				if (f < a || f > l || (a === f && !o) || (l === f && !c)) {
					e = !1
					break
				}
			}
		}
		if (e) return !0
	}
	return !1
}
